import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './NotAuthorized.css';

const NotAuthorized = ({ redirectTo = '/dashboard', delay = 3000 }) => {
  const navigate = useNavigate();
  const [countdown, setCountdown] = useState(Math.ceil(delay / 1000));

  // Redirection automatique après le délai spécifié
  useEffect(() => {
    const redirectTimer = setTimeout(() => {
      navigate(redirectTo);
    }, delay);

    // Compte à rebours
    const countdownInterval = setInterval(() => {
      setCountdown(prevCount => {
        if (prevCount <= 1) {
          clearInterval(countdownInterval);
          return 0;
        }
        return prevCount - 1;
      });
    }, 1000);

    return () => {
      clearTimeout(redirectTimer);
      clearInterval(countdownInterval);
    };
  }, [navigate, redirectTo, delay]);

  return (
    <div className="not-authorized-container">
      <div className="not-authorized-icon">⚠️</div>
      <h1 className="not-authorized-title">Accès non autorisé</h1>
      <p className="not-authorized-message">
        Vous n'avez pas les autorisations nécessaires pour accéder à cette page.
        Vous allez être redirigé vers votre tableau de bord.
      </p>
      <button 
        className="btn btn-primary" 
        onClick={() => navigate(redirectTo)}
      >
        Aller au tableau de bord
      </button>
      <div className="redirect-timer">
        Redirection dans {countdown} seconde{countdown !== 1 ? 's' : ''}...
      </div>
    </div>
  );
};

export default NotAuthorized;